





import { Component, Vue, Mixins } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { IActionType } from '@/system/store'
import { ICredentials } from '@/features/auth/store'
import { authLocalisationKeys } from '@/features/auth/auth.localisation'
import { CLEAR_AUTH_DATA } from '@/system/store/action-types'

import Notification from '@/shared/Notification.mixin.vue'
import Login from '@/features/auth/components/Login.component.vue'
import { CheckRoleGuard } from '@/features/auth/auth.router.guards'

@Component({
  components: { Login }
})
export default class LoginView extends Mixins(Notification) {
  private translations: any = authLocalisationKeys

  @Action(CLEAR_AUTH_DATA) clearAuth!: IActionType

  async beforeRouteLeave (to: any, from: any, next: any): Promise<any> {
    return CheckRoleGuard(to, from, next)
      .catch(this.guardErrorHandler)
  }

  private created () {
    this.clearAuth()
  }

  private guardErrorHandler (ex: Error): void {
    const { message } = ex
    let errorMessage = this.$t(this.translations.SMTH_HAPPEN) as string

    if (this.translations[message]) {
      errorMessage = this.$t(this.translations[message]) as string
    }
    this.showError(errorMessage)
  }
}
